import { SheetMusicContent } from "../index";
import { getXmlFromSheetMeasures } from "./getXmlFromSheetMeasures";
import create from "./sheetHtmlView";

export const renderSheetMusicToHtml = (
  content: SheetMusicContent,
  id?: string,
) => create(getXmlFromSheetMeasures(content), id);
